import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "micevski_transfers_to_rfs" }) {
    ...NewsInfo
  }
}`

export default class NewsText extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>После долгих переговоров полузащитник и капитан македонского ФК «Вардар», Дарко Мицевски, подписал контракт с ФК РФШ!</p>
        </div>
      </div>
    )
  }
}